import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { reloadedStatus } from './archivedAllocationRefresh';
export const isNewSubmeterCycle = _ref => {
  let store = _ref.store,
    applyBill = _ref.applyBill,
    utility = _ref.utility;
  return !!store.account.featureFlagsStore.getEnableSubmeterBilling && ((utility === null || utility === void 0 ? void 0 : utility.allocationMethod) === 'BySubmeter' || (applyBill === null || applyBill === void 0 ? void 0 : applyBill.allocationMethod) === 'Submeter') && (applyBill === null || applyBill === void 0 ? void 0 : applyBill.isNewSubmeter) === true;
};

// Whether this property's store holds the table the response names, by the bill's identity. A table with `bill: null`
// is held by a utility with no bill; one with a bill, by a utility holding that bill's id.
const holdsResponseTable = (utility, table) => {
  var _utility$bill, _utility$bill2;
  if (!utility) return false;
  if (!table.bill) return !((_utility$bill = utility.bill) !== null && _utility$bill !== void 0 && _utility$bill.id);
  return ((_utility$bill2 = utility.bill) === null || _utility$bill2 === void 0 ? void 0 : _utility$bill2.id) === table.bill.id;
};

// Re-reads the cycle table: an empty utility.bill means no live bill. A New Submeter header takes the server's status.
// isRead is whether the read succeeded and left this property's store holding what the response says: the table's
// bill, or the server saying this utility has no table. A response the store did not take reads as failed.
export const readCycleBill = async _ref2 => {
  var _allocations$utilityB, _allocations$utilityB2, _resp$response;
  let store = _ref2.store,
    billingTab = _ref2.billingTab,
    allocations = _ref2.allocations,
    propertyId = _ref2.propertyId,
    billingCycleId = _ref2.billingCycleId,
    utilityId = _ref2.utilityId,
    isSubmeterUtility = _ref2.isSubmeterUtility;
  const resp = await store.allocations.getAllocationTableAggregateAsync.run({
    billingCycleId,
    propertyId,
    utilityId
  });
  if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return {
    isRead: false,
    utility: null
  };
  const utility = (_allocations$utilityB = allocations === null || allocations === void 0 || (_allocations$utilityB2 = allocations.utilityById) === null || _allocations$utilityB2 === void 0 ? void 0 : _allocations$utilityB2.get(billingCycleId + utilityId)) !== null && _allocations$utilityB !== void 0 ? _allocations$utilityB : null;
  const applyBill = billingTab.applyBill;
  const isOpenCycle = (applyBill === null || applyBill === void 0 ? void 0 : applyBill.propertyId) === propertyId && (applyBill === null || applyBill === void 0 ? void 0 : applyBill.billingCycleId) === billingCycleId && (applyBill === null || applyBill === void 0 ? void 0 : applyBill.utilityId) === utilityId;
  if (isSubmeterUtility && utility && isOpenCycle) {
    billingTab.setApplyBill(_objectSpread(_objectSpread({}, applyBill), {}, {
      status: reloadedStatus(utility)
    }));
  }
  const tables = (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.utilityTables;
  if (!Array.isArray(tables)) return {
    isRead: false,
    utility
  };
  const table = tables.find(candidate => candidate.utilityId === utilityId);
  return {
    isRead: !table || holdsResponseTable(utility, table),
    utility
  };
};
export const refreshCycleBill = async args => (await readCycleBill(args)).utility;